import { Box, CardMedia, Modal, Typography } from "@mui/material";
import { Type } from "lucide-react";
import React from "react";

const Boomt = ({ two, onClose }) => {
  return (
    <Modal
      open={two}
      onClose={onClose}
      sx={{
        background:
          "linear-gradient(180deg, rgba(20,25,60,0.55), rgba(10,10,25,0.45))",
        border: "1px solid rgba(255,255,255,0.15)",
        backdropFilter: "blur(16px)",
        WebkitBackdropFilter: "blur(16px)",

        boxShadow: "0 12px 40px rgba(0,0,0,0.55)",
        p: 3,
        color: "#fff",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 1400,
          height: 700,
          borderRadius: "24px",

          // GLASS BACKGROUND
          background:
            "linear-gradient(180deg, rgba(20,25,60,0.55), rgba(10,10,25,0.45))",
          border: "1px solid rgba(255,255,255,0.15)",
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",

          boxShadow: "0 12px 40px rgba(0,0,0,0.55)",
          p: 3,
          color: "#fff",
        }}
      >
        <Typography
          sx={{
            fontWeight: 300,
            textAlign: "left",
            mb: 2,
            fontSize: "20px",
            // textShadow: "0 0 6px rgba(57, 194, 15, 0.7)",
            color: "#98f108ff",
          }}
        >
          Хилийн боомтод нэвтрэх зөвшөөрөл
        </Typography>

        <CardMedia
          component="iframe"
          src="https://www.youtube.com/embed/hjsTP2lNriM?autoplay=1&mute=0&loop=1&playlist=hjsTP2lNriM&controls=1"
          allow="autoplay; encrypted-media"
          allowFullScreen
          style={{
            width: "100%",
            height: "650px",
            borderRadius: "18px",
            border: "1px solid rgba(255,255,255,0.1)",
            boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
          }}
        />
      </Box>
    </Modal>
  );
};

export default Boomt;
